import axios from 'axios';
import { auth } from '../firebase';

export async function axiosWithAuth() {
  const user = auth.currentUser;

  const baseURL = process.env.NODE_ENV === 'development'
  ?  process.env.REACT_APP_DEV_URL
  : 'https://revisaja-0b95e6e3ff11.herokuapp.com';

  
  if (!user) throw new Error('Usuário não autenticado');

  const token = await user.getIdToken();
  //console.log(`[Auth] Token obtido para usuário: ${user.uid}`);
  const instance = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return instance;
}
